import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import { wrapperStyle } from "./style";
import { ReactNode, useEffect, useState } from "react";
import { ParsedLog, useAPI } from "../../../../../api/useAPI";
import Content from "./Content";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  handleClose: () => void;
  logGroup: string;
  open: boolean;
}

export default ({ open, handleClose, logGroup }: Props) => {
  const { getLogsContent } = useAPI();
  const [currentContent, setCurrentContent] = useState("");
  const [currentSummary, setCurrentSummary] = useState<ParsedLog>();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (logGroup && open) {
      setLoading(true);
      getLogsContent(logGroup)
        .then((response) => {
          setLoading(false);
          if (!response.success) {
            throw new Error(response.error);
          }

          setCurrentContent(response.data.content);
          setCurrentSummary(response.data.summary);
        })
        .catch((err) => {
          console.error(err);
          setError(`Error during fetching of logs overview: ${err.message}`);
        });
    }
  }, [logGroup, open]);

  function renderChips(currentSummary: ParsedLog | undefined): ReactNode {
    if (!currentSummary) {
      return null;
    }
    const hasErrors = currentSummary?.errors > 0;
    const hasWarnings = currentSummary?.warinings > 0;

    return (
      <>
        <Chip
          label={`${currentSummary?.errors} errors`}
          color={hasErrors ? "error" : "success"}
        />
        <Chip
          label={`${currentSummary?.warinings} warnings`}
          color={hasWarnings ? "warning" : "success"}
        />
      </>
    );
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-descripiton"
    >
      <Box sx={wrapperStyle}>
        {error ? (
          error
        ) : loading ? (
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="h5" component="h1" noWrap>
                {logGroup}
              </Typography>
              {renderChips(currentSummary)}
              <Box sx={{ marginLeft: "auto" }}>
                <Button variant="text" onClick={() => handleClose()}>
                  <CloseIcon />
                </Button>
              </Box>
            </Box>
            {currentSummary ? (
              <Content
                contentStr={currentContent}
                currentSummary={currentSummary}
              />
            ) : null}
          </>
        )}
      </Box>
    </Modal>
  );
};
